<fc-outlined-multi-select
  [required]="required"
  [label]="label"
  [control]="control"
  [options]="maintenanceTypes"
  [showAllOption]="showAllOption"
></fc-outlined-multi-select>
